import { useState, useEffect } from "react";
import Button from "../../Components/Button";
import EventInformation from "./EventInformation";
import PageTemplate from "./PageTemplate";
import axios from "axios";
import {
  GET_EVENT_INFO_API,
  GET_TEMPLATE_LIST_API,
  UPDATE_EVENT_INFO_API,
} from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import LoadingInComponent from "../../Components/LoadingInComponent";
import { LoadingOverlay } from "../../Components/LoadingOverlay";
import Breadcrumb from "../../Components/Breadcrumb";
import Customizations from "./Customizations";
import MonetaryContribution from "./MonetaryContribution";

const EventPage = () => {
  const [activeTab, setActiveTab] = useState("Event Information");

  const [eventInfo, setEventInfo] = useState({});

  const [templateList, setTemplateList] = useState([]);
  const [templateListMeta, setTemplateListMeta] = useState({});
  const [templateCustomizations, setTemplateCustomizations] = useState({
    title_font: "Arial",
    content_font: "Arial",
    theme_color: "#000000",
    image: "",
  });
  const [monetaryContributionSettings, setMonetaryContributionSettings] =
    useState({
      accept_contribution: false,
      title: "",
      description: "",
      receive_options: "occurlab",
      qr_code: "",
      amount_options: [],
    });

  const [loading, setLoading] = useState(false);
  const [overlayLoading, setOverlayLoading] = useState(false);

  const { toast } = useToast();

  const tabButtons = [
    "Event Information",
    // "Page Template",
    "Customizations",
    "Monetary Contribution Settings",
  ];

  const breadcrumbItems = [
    { label: "Event Page" },
    {
      label:
        activeTab === "Event Information"
          ? "Event Information"
          : "Page Template",
    },
    { label: "Edit" },
  ];

  const fetchEventInfo = () => {
    setLoading(true);
    try {
      axios
        .get(GET_EVENT_INFO_API, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("bearer_token")}`,
          },
          params: { eventId: localStorage.getItem("event_id") },
        })
        .then((response) => {
          setEventInfo(response.data.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Failed to fetch event info", error);
          toast("Failed to fetch event info", "error");
        });
    } catch (error) {
      setLoading(false);
      console.log("Failed to fetch event info", error);
      toast("Failed to fetch event info", "error");
    }
  };

  // const fetchTemplateList = (page = 1) => {
  //   setLoading(true);
  //   try {
  //     axios
  //       .get(GET_TEMPLATE_LIST_API, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("bearer_token")}`,
  //         },
  //         params: { page: page },
  //       })
  //       .then((response) => {
  //         setTemplateList(response.data.data);
  //         setTemplateListMeta(response.data.meta.pagination);
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         console.log("Failed to fetch template list", error);
  //         toast("Failed to fetch template list", "error");
  //       });
  //   } catch (error) {
  //     setLoading(false);
  //     console.log("Failed to fetch template list", error);
  //     toast("Failed to fetch template list", "error");
  //   }
  // };

  const handleUpdate = () => {
    if (
      eventInfo.name !== "" &&
      eventInfo.venue !== "" &&
      eventInfo.date !== "" &&
      eventInfo.time !== ""
    ) {
      setLoading(true);
      setOverlayLoading(true);
      try {
        axios
          .put(UPDATE_EVENT_INFO_API, eventInfo, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("bearer_token")}`,
            },
            params: { eventId: localStorage.getItem("event_id") },
          })
          .then((response) => {
            setLoading(false);
            localStorage.setItem("seat", eventInfo.seat_management);
            localStorage.setItem("dietary", eventInfo.dietary_management);
            window.location.reload();
          })
          .catch((error) => {
            setLoading(false);
            console.log("Failed to update event info", error);
            toast("Failed to update event info", "error");
          });
      } catch (error) {
        setLoading(false);
        console.log("Failed to update event info", error);
        toast("Failed to update event info", "error");
      }
    } else {
      toast("Please fill in all required fields", "error");
    }
  };

  // const handlePageClick = (e) => {
  //   fetchTemplateList(e.selected + 1);
  // };

  useEffect(() => {
    fetchEventInfo();
    // fetchTemplateList();
  }, []);

  return (
    <div className="flex flex-col w-full h-full">
      {overlayLoading && <LoadingOverlay />}
      {eventInfo && (
        <LoadingInComponent isLoading={loading}>
          {!loading && (
            <div className="flex flex-col w-full h-full p-[32px] no-scrollbar overflow-y-auto gap-[24px]">
              {/* Breadcrumb */}
              <Breadcrumb items={breadcrumbItems} />

              {/* Title and buttons */}
              <div className="flex w-full justify-between items-center">
                <h1 className="text-[29px]">{activeTab}</h1>
                <div className="flex w-fit items-center gap-[8px]">
                  <Button variant="secondary">Preview</Button>
                  <Button variant="primary" onClick={handleUpdate}>
                    Save Changes
                  </Button>
                </div>
              </div>

              {/* Event information section */}
              <div className="flex flex-col w-full h-fit gap-[24px]">
                {/* Tab bar */}
                <div className="flex w-full h-fit border-b border-[#EFF0F2] gap-[8px]">
                  {tabButtons.map((tab) => (
                    <Button
                      key={tab}
                      variant={
                        activeTab === tab
                          ? "tab_button_selected"
                          : "tab_button_default"
                      }
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </Button>
                  ))}
                </div>

                {/* Active tabs */}
                <div className="w-full h-full">
                  {activeTab === "Event Information" && (
                    <EventInformation
                      eventInfo={eventInfo}
                      setEventInfo={setEventInfo}
                    />
                  )}
                  {/* {activeTab === "Page Template" && (
                    <PageTemplate
                      handlePageClick={handlePageClick}
                      templateList={templateList}
                      templateListMeta={templateListMeta}
                      eventInfo={eventInfo}
                      setEventInfo={setEventInfo}
                    />
                  )} */}
                  {activeTab === "Customizations" && (
                    <Customizations
                      templateCustomizations={templateCustomizations}
                      setTemplateCustomizations={setTemplateCustomizations}
                    />
                  )}
                  {activeTab === "Monetary Contribution Settings" && (
                    <MonetaryContribution
                      monetaryContributionSettings={
                        monetaryContributionSettings
                      }
                      setMonetaryContributionSettings={
                        setMonetaryContributionSettings
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </LoadingInComponent>
      )}
    </div>
  );
};

export default EventPage;
